"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLink = exports.Button = exports.ButtonType = exports.ButtonAppearance = void 0;
const React = __importStar(require("react"));
const utils_1 = require("./custom-text-fields/utils");
const theme_provider_1 = require("@volkswagen-onehub/components-core/dist/theme-provider");
const color_tokens_1 = require("./theme/color-tokens");
var ButtonAppearance;
(function (ButtonAppearance) {
    ButtonAppearance["Primary"] = "Primary";
    ButtonAppearance["Secondary"] = "Secondary";
})(ButtonAppearance || (exports.ButtonAppearance = ButtonAppearance = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["Submit"] = "submit";
    ButtonType["Reset"] = "reset";
    ButtonType["Button"] = "button";
})(ButtonType || (exports.ButtonType = ButtonType = {}));
const buttonStyle = (0, theme_provider_1.css) `
  ${props => props.stretchContent && 'width: 100%;'};
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  min-height: 44px;
  margin: 0;
  padding: 0 ${props => props.theme.size.static450};
  border: 2px solid;
  border-radius: 22px;
  outline: none;
  transition: all 0.2s ease-in-out;
  ${props => {
    const { appearance } = props;
    const { button } = (0, color_tokens_1.getColorTokens)(props, appearance);
    return props.disabled
        ? (0, theme_provider_1.css) `
          cursor: not-allowed;
          background: ${button.disabled.background};
          border-color: ${button.disabled.border};
          color: ${button.disabled.color};
        `
        : (0, theme_provider_1.css) `
          & {
            cursor: pointer;
            background: ${button.default.background};
            border-color: ${button.default.border};
            color: ${button.default.color};
          }
          @media (hover: hover) {
            :hover,
            :focus {
              background: ${button.hover.background};
              border-color: ${button.hover.border};
              color: ${button.hover.color};
            }
            :focus {
              ${(0, utils_1.createA11yOutlineStyles)(props)}
            }
          }
          :active {
            background: ${button.active.background};
            border-color: ${button.active.border};
            color: ${button.active.color};
          }
        `;
}};
`;
const StyledButton = theme_provider_1.styled.button `
  ${buttonStyle}
`;
const StyledButtonLink = theme_provider_1.styled.a `
  text-decoration: none;
  ${buttonStyle}
`;
const Button = props => {
    const { appearance = ButtonAppearance.Secondary, children, disabled, innerRef, onClick, stretchContent, type, className } = props;
    return (React.createElement(StyledButton, { disabled: disabled, appearance: appearance, type: type, onClick: onClick, stretchContent: stretchContent, ref: innerRef, className: className }, children));
};
exports.Button = Button;
const ButtonLink = props => {
    const { appearance = ButtonAppearance.Secondary, children, disabled, href, target, innerRef, rel, title, onClick, stretchContent } = props;
    return (React.createElement(StyledButtonLink, { disabled: disabled, appearance: appearance, href: href, target: target, ref: innerRef, rel: rel, title: title, onClick: onClick, stretchContent: stretchContent, className: "button-link-container" }, children));
};
exports.ButtonLink = ButtonLink;
